// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import KeldanMarkadirPage from '../../components/KeldanMarkadir/KeldanMarkadir';

const KeldanMarkadir: React.FC = () => {
    return (
        <Entrypoint>
            <KeldanMarkadirPage />
        </Entrypoint>
    );
}

export default KeldanMarkadir;